/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=11fef772&"
import script from "./loading.vue?vue&type=script&lang=ts&"
export * from "./loading.vue?vue&type=script&lang=ts&"
import style0 from "./loading.vue?vue&type=style&index=0&id=11fef772&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports